import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "user-dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { addStorePersonApi } from '@/service/modules/user';
export default /*#__PURE__*/_defineComponent({
  __name: 'user-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: String,
      default: 'add'
    },
    itemData: {
      type: Object,
      default: () => {}
    },
    sourceGroupList: {
      type: Array,
      default: () => {}
    }
  },
  emits: ['closeDialog', 'restData'],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    const formRef = ref();
    const subBtnLoading = ref(false);
    const form = reactive({
      group1_id: [],
      name: '',
      id: null
    });
    const cascaderProps = {
      label: 'name',
      value: 'id'
    };
    const rules = {
      name: [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur'
      }, {
        min: 2,
        max: 5,
        message: '姓名2-5位',
        trigger: 'blur'
      }],
      group1_id: [{
        required: true,
        message: '请选择分组',
        trigger: 'change'
      }]
    };
    function restForm() {
      form.group1_id = [];
      form.name = '';
      form.id = null;
      formRef.value?.resetFields();
    }
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning('正在保存，请稍后~~');
      restForm();
      emit('closeDialog');
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      let params = {
        id: form.id,
        name: form.name,
        group1_id: form.group1_id[form.group1_id.length - 1]
      };
      try {
        let res = await addStorePersonApi(params);
        ElMessage.success('操作成功');
        subBtnLoading.value = false;
        closeDialog();
        emit('restData');
      } catch {} finally {
        subBtnLoading.value = false;
      }
    }
    const title = computed(() => {
      if (props.dialogType === 'add') {
        return '设为分销';
      }
    });
    watch(() => props.dialogVisible, newValue => {
      if (newValue) {
        form.id = props.itemData.id;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "25%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[3] || (_cache[3] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "分组",
            prop: "group1_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_cascader, {
              class: "w100",
              placeholder: "请选择分组",
              modelValue: form.group1_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.group1_id = $event),
              options: __props.sourceGroupList,
              clearable: "",
              props: cascaderProps
            }, null, 8, ["modelValue", "options"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "姓名",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.name = $event),
              placeholder: "请输入姓名"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});